module.exports = __webpack_public_path__ + "static/media/love-carlisle-bench--resized.79106562.jpg";